import { useEffect, useState } from "react";

/** `null` until mounted (SSR-safe), then boolean. */
export function useMatchMedia(query) {
  const [matches, setMatches] = useState(() => {
    if (typeof window === "undefined") return null;
    return window.matchMedia(query).matches;
  });

  useEffect(() => {
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [query]);

  return matches;
}
